import Vue from "vue";
import Vuex from "vuex";
import * as loginmaster from "@/store/modules/loginU.js";
import * as exam from "@/store/modules/exam.js";
import * as admin from "@/store/modules/admin.js";
import * as dashboard from "@/store/modules/dashboard.js";
import VuexPersist from "vuex-persist";
import { Plugins } from "@capacitor/core";
// import { Preferences } from '@capacitor/preferences';
// import { Capacitor } from "@capacitor/core";

const { Storage } = Plugins;

Vue.use(Vuex);

const vuexLocal = new VuexPersist({
  key: "quicktest",
  storage: Storage,
  reducer: state => ({
    loginmaster: state.loginmaster,
    exam: state.exam,
    // dashboard: state.dashboard,
    // admin: state.admin,
    start_config: state.start_config,
    ongoing: state.ongoing,
    loggedout: state.loggedout
  })
});

export default new Vuex.Store({
  state: {
    start_config: {},
    ongoing: false,
    loggedout: false,
    isNativePlatform: false,
    appVersion : "1.0.0"
  },
  mutations: {
    SET_CONFIG_ROOT(state, config) {
      state.start_config = config;
    },
    UPDATE_TIME_ROOT(state, newtime) {
      const getcconfig = state.start_config;

      let completed = "";
      let start = "";
      if (newtime == 0) {
        completed = "Yes";
        start = "No";
      } else {
        completed = "No";
        start = "Continue";
      }

      const newconfig = {
        completed: completed,
        start: start,
        category: getcconfig.category,
        mode: getcconfig.mode,
        mode_config: getcconfig.mode_config,
        title: getcconfig.title,
        structure: getcconfig.structure,
        course: getcconfig.course,
        level: getcconfig.level,
        institution_id: getcconfig.institution_id,
        institution: getcconfig.institution,
        institution_shortname: getcconfig.institution_shortname,
        total_time: newtime,
        track_id: getcconfig.track_id,
        totalquestions: getcconfig.totalquestions,
        test_source: getcconfig.test_source,
        config_dir: getcconfig.config_dir
      };
      //console.log(newconfig)
      state.start_config = newconfig;
    },
    SET_ONGOING(state) {
      state.ongoing = true;
    },
    LOGGED_OUT(state) {
      state.loggedout = false;
    },
    SET_NATIVE_PLATFORM(state, value) {
      state.isNativePlatform = value;
    },
    SET_APP_VERSION(state, value) {
      state.appVersion = value;
    },
    DESTROY_ALL(state) {
      state.ongoing = false;
      state.start_config = {};
      state.loggedout = true;
    }
  },
  actions: {
    destroyalL({ commit }) {
      commit("DESTROY_ALL");
      // dispatch("loginmaster/updatetrial", null, {
      //   root: true
      // });
    },
    async logOut({ commit, dispatch }) {
      let now = new Date();
      now.setFullYear(now.getFullYear() - 20);
      document.cookie = `remember=;expires=${now.toUTCString()}`;
      document.cookie = `qid=;expires=${now.toUTCString()}`;

      commit("DESTROY_ALL");
      dispatch("loginmaster/logOut", null, {
        root: true
      });
      dispatch("exam/logOut", null, {
        root: true
      });
      dispatch("dashboard/logOut", null, {
        root: true
      });
      dispatch("admin/logOut", null, {
        root: true
      });
    },
    loggedOut({ commit }) {
      commit("LOGGED_OUT");
    },
    setNativePlatform({ commit }, value) {
      commit("SET_NATIVE_PLATFORM", value);
    },
    setAppVersion({ commit }, value) {
      commit("SET_APP_VERSION", value);
    }
  },
  getters: {},

  modules: {
    loginmaster,
    exam,
    admin,
    dashboard
  },
  plugins: [vuexLocal.plugin]
});
